import { observer } from 'mobx-react-lite'
import React from 'react'

import { useGameContext } from '@/pages/game/context/game-context'
import StoreService from '@/store/StoreService'

import { JumbotronVideo } from './JumbotronVideo'

export const JumbotronVideoTrivia = observer(
  function JumbotronVideoTrivia(): React.ReactElement | null {
    const { gameData, isCreatedGame } = useGameContext()

    if (gameData.type !== 'trivia') return null

    const { currentItemIndex, sourceListMeta } = gameData

    const getVideoUrl = () => {
      const { host } = StoreService.getStore()

      if (isCreatedGame) {
        const triviaListVideo = sourceListMeta?.videoPreGame?.url
        const brandingVideo = host?.settings?.branding?.jumbotron?.videoPreGame?.url

        return triviaListVideo || brandingVideo
      }

      if (currentItemIndex === null) return

      const triviaListVideo = sourceListMeta?.video?.url
      const brandingVideo = host?.settings?.branding?.jumbotron?.video?.url

      return triviaListVideo || brandingVideo
    }

    const url = getVideoUrl()

    if (!url) return null

    return <JumbotronVideo url={url} />
  }
)
